import { ComboBoxModel } from "@genexus/chameleon-controls-library";
import { ObjectType } from "../../../../../components";

export const typesToComboBoxItemModel = (
  objectTypeModel: ObjectType[]
): ComboBoxModel =>
  objectTypeModel.map(objectType => ({
    value: objectType.id,
    caption: objectType.name === "All" ? "All Types" : objectType.name || "",
    startImgSrc: objectType.icon
  }));
